<mat-dialog-content class="dialog-content" #dialogContent>
  <div class="header">あなたが所属している職場/店舗を1つ選択してください。</div>
  <div class="dialog-desc">アンケートを回答する職場/店舗になります。</div>
  <div class="dialog-note">※ 原則、初回の回答から変更しないでください。</div>

  @if (options.length === 0) {
    <a class="no-options-link" (click)="onGoToProfile()">
      職場/店舗が設定されていません。個人設定で担当を選択してください。
    </a>
  } @else {
    <div class="option-list">
      @for (option of options; track option.id) {
        <label class="radio-label">
          <input type="radio" name="workplace" [checked]="selection.workplaceId === option.id" (change)="onSelectWorkplace(option)">
          <span class="radio-text">{{ option.path }}</span>
        </label>
      }
    </div>
  }

  <div class="scope-question">
    <div class="scope-title">あなた自身が日常的に勤務している/把握できる職場の単位はどちらですか？</div>
    <div class="option-list">
      <label class="radio-label">
        <input type="radio" name="scopeType" value="whole" [(ngModel)]="selection.scopeType" (change)="onScopeTypeChange()">
        <span class="radio-text">選択した職場そのもの</span>
      </label>
      <label class="radio-label">
        <input type="radio" name="scopeType" value="part" [(ngModel)]="selection.scopeType" (change)="onScopeTypeChange()">
        <span class="radio-text">選択した職場の一部</span>
      </label>
    </div>
  </div>

  @if (selection.scopeType === 'part') {
    <div class="part-field">
      <div class="part-label">その範囲のおおよその組合員数を入力してください。</div>
      <div class="part-input-row">
        <input
          type="text"
          class="member-count-input"
          placeholder="半角数字"
          [attr.maxlength]="Constant.fvMaxSurveyPartMemberCount"
          inputmode="numeric"
          [value]="selection.partMemberCount"
          (input)="onOnlyNumber($event)"
        >
        <span class="unit">人</span>
      </div>
    </div>

    <div class="part-field">
      <div class="part-label">その勤務範囲の名称を入力してください。</div>
      <input
        type="text"
        class="part-name-input"
        [attr.maxlength]="Constant.fvMaxSurveyPartName"
        [(ngModel)]="selection.partName"
      >
      <div class="char-count">{{ selection.partName.length }} / {{ Constant.fvMaxSurveyPartName }}</div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="actions-content">
  <button mat-raised-button (click)="onCancel()">キャンセル</button>
  <button mat-raised-button class="yes-btn" [disabled]="!isValid()" (click)="onSelect()">選択</button>
</mat-dialog-actions>
